import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { motion } from "framer-motion";
import notFoundImage from '../../assets/images/not-found.png'; // Replace with your 404 image

const MotionTypography = motion(Typography);
const MotionBox = motion(Box);

const PageNotFound = () => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        background: "#f5f5f5",
        color: "#333",
        textAlign: "center",
        flexDirection: "column",
        gap: 2,
        p: { xs: 3, md: 6 },
      }}
    >
      {/* Animated Typography for 404 */}
      <MotionTypography
        variant="h2"
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        sx={{ fontWeight: "bold", textShadow: "0px 4px 10px rgba(0,0,0,0.5)" }}
      >
        404 - Page Not Found 🚫
      </MotionTypography>

      <MotionTypography
        variant="h6"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.3 }}
        sx={{ maxWidth: "600px", mx: "auto" }}
      >
        Oops! The page you're looking for doesn't exist. Please check the URL
        or return to the homepage.
      </MotionTypography>

      {/* Illustration */}
      <MotionBox
        component="img"
        src={notFoundImage} // Replace with your image
        alt="Page Not Found"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.5 }}
        sx={{
          maxWidth: "300px",
        }}
      />

      {/* Button to Navigate Home */}
      <MotionBox
        whileHover={{ scale: 1.05 }}
      >
        <Button
          variant="contained"
          sx={{
            background: "linear-gradient(90deg, #06beb6, #48b1bf)",
            color: "white",
            fontWeight: "bold",
            px: 4,
            py: 1.5,
            borderRadius: "30px",
            boxShadow: "0 3px 10px rgba(0,0,0,0.2)",
            "&:hover": {
              background: "linear-gradient(90deg, #48b1bf, #06beb6)",
            },
          }}
          onClick={() => window.location.href = "/"}
        >
          Go to Homepage
        </Button>
      </MotionBox>
    </Box>
  );
};

export default PageNotFound;
